import config from "../services/config";

const PUSH_PROVIDER_WEBPUSH = "webpush";
const PUSH_PROVIDER_FIREBASE = "firebase";

export const getPushProvider = () => {
  const configuredProvider = (
    config.PUSH_PROVIDER ||
    config.REACT_APP_PUSH_PROVIDER ||
    PUSH_PROVIDER_WEBPUSH
  )
    .toString()
    .toLowerCase();

  if (configuredProvider === PUSH_PROVIDER_FIREBASE) {
    return PUSH_PROVIDER_FIREBASE;
  }

  return PUSH_PROVIDER_WEBPUSH;
};

export const isFirebasePushProvider = () => getPushProvider() === PUSH_PROVIDER_FIREBASE;
